// action
import {
    SAVE_SCHEDULE_TIMING_CUSTOMIZE,
    SAVE_SCHEDULE_TIMING_CUSTOMIZE_FAIL,
    SAVE_SCHEDULE_TIMING_CUSTOMIZE_SUCCESS,
    SAVE_SCHEDULE_TIMING_CUSTOMIZE_RESET
} from '../action/saveScheduleTimingCustomizeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "", 
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_SCHEDULE_TIMING_CUSTOMIZE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_SCHEDULE_TIMING_CUSTOMIZE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_SCHEDULE_TIMING_CUSTOMIZE_SUCCESS:
            return {
                ...state,
                apiState: "success", 
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_SCHEDULE_TIMING_CUSTOMIZE_RESET:
            return initialState
        default:
            return state
    }
}